import sm from './haxe_SequencesManager'

export const SequencesFile =  sm.sequences.SequencesFile
export default sm.sequences.SequencesManager.instance